module.exports = __webpack_public_path__ + "img/MX-A018030C-AS.a6bdf0f2.png";